Ext.define('SA.view.sidebar.data.ImportsList', {
    alias: 'widget.imports-list',
    extend: 'Ext.Component',

    cls: 'sa-imports-list',

    tpl: [
        '<tpl for=".">',
            '<div class="sa-imports-list-item" data-dataset="{id:htmlEncode}">',
                '<svg class="sa-imports-list-item-icon sa-imports-list-item-icon-closed"><use href="#sa-icon-folder-closed"></use></svg>',
                '<svg class="sa-imports-list-item-icon sa-imports-list-item-icon-open"><use href="#sa-icon-folder-open"></use></svg>',
                '<span class="sa-imports-list-item-name">{name:htmlEncode}</span>',
            '</div>',
        '</tpl>'
    ],

    clearSelected() {
        this.el.select('.sa-imports-list-item-selected').removeCls('sa-imports-list-item-selected');
    },

    getItemEls() {
        return this.el.query('.sa-imports-list-item');
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onItemClick, this, {delegate: '.sa-imports-list-item'});
    },

    onItemClick(ev, el) {
        var priorSelectedEl = this.el.down('.sa-imports-list-item-selected', true);

        this.clearSelected();

        if (el === priorSelectedEl) {
            this.fireEvent('deselect');
        }
        else {
            Ext.fly(el).addCls('sa-imports-list-item-selected');

            this.fireEvent('select', el, el.getAttribute('data-dataset'));
        }
    },

    refresh(datasets) {
        this.update(datasets);
    },

    setState(state) {
        var {country, isImportsMode} = state,
            userDatasets = SA.data.UserDatasets.getDatasetsForCountry(country);

        this.setVisible(isImportsMode);
        this.refresh(userDatasets);
    }
});